export const MAP_STYLE = "routescc/ckawncfk14vv21ik9cdl0oy7p";
export const MAILCHIMP_ENDPOINT =
  "https://routes.us10.list-manage.com/subscribe/post?u=e8430efd4e06a5e7e0a8df852&amp;id=42dc1162ab";
export const YEAR = "2021";
